import { QueueCategory } from '../ticket/qaticket-config.component';
import { TicketCode } from "./ticket";

export class QATicket {
    ID: number;
    GCTicketNumber: string;
    GCTicketTakenBy: string;
    ExcavatorFeedback: string = "";
    NotificationFeedback: string = "";
    LocationFeedback: string = "";
    RemarksFeedback: string = "";
    MappingFeedback: string = "";
    EndFeedback: string = "";
    Response: QAResponse[];
    GCTicketCorrection: string;
    QATicketNotes: QATicketNotes;
    IsEvaluation: boolean = false;
    PacketID: number;
    GCTicketID: string;
}

export class QAResponse {
    Section: Section;
    QuestionID: number;
    QuestionText: string;
    ResponseValue: string;
    CanNA: boolean;
    CriticalLevel: number;
    AnswerValues: string[] = [];
    CriticalLevelValues: number[] = [];
    ValidResponse: string;
    GCTicketID: string;
}

export class Question {
    ID: number;
    QuestionText: string;
    Section: Section;
    IsActive: boolean;
    CanNA: boolean;
    Condition: string;
    Order: number;
    CriticalLevel: number;
    CustomResponse: string;
    QueueCategory: string;
    ValidResponse: string;
}
export class ParseJsonQuestion {
    attribute: string;
    value: string[];
}
export enum Section {
    Excavator,
    Notification,
    Location,
    Remarks,
    Mapping,
    Ending
}

export class ViewTicketResponse {
    QATicket: QATicket;
    TicketQuestions: Question[];
}


export class QACompletedTicket {
    ID: number;
    GCTicketNumber: string;
    Responses: string;
    Start: Date;
    Complete: Date;
    QualityCompletedBy: string;
    ExcavatorFeedback: string;
    LocationFeedback: string;
    RemarksFeedback: string;
    MappingFeedback: string;
    EndFeedback: string;
    TicketWorkArea: string;
    TicketWorkAreaCode: TicketCode[];
    GCTicketTakenBy: string;
    QueueCategory: string;
    PacketID: number;
    PacketName: string;
}

//Send feedback 
export class SendFeedBack {
    IsSendFeedBack: boolean;
    SendFeedBackText: string;
    SendFeedBackTo: string[];
    QARole: string;
    Status: string;
}

export class SendFeedBackToEmailAndType {
    SendFeedBackEmail: string;
    TemplateType: string;
}

export class RolesForSendingFeedback {
    role: Role[];
}

export class Role {
    name: string;
}

export class QATicketNotes {
    ID: number;
    TicketID: number;
    CreatedBy: string;
    Subject: string = "";
    Message: string = "";
    Creation: Date;
    GCTicketID: string;
}

export class QATicketActivity{
    ID: number;
    TicketID: number;
    StartTicketNoteID: number;
    CompleteTicketNoteID: number;
    ActivityName: string;
    ActivityStartBy: string;
    ActivityCompleteBy: string;
    IsComplete: boolean;
    Creation: Date;
    Completion: Date;
    Status: string;
    DateOn: Date;
    UserBy: string;
    GCTicketID: string;
}

export class QATicketDisputeDetails{
    QATicketId: number;
    UserName: string;
    Subject: string;
    Message: string;
    Activity: string;
    QuestionText: string;
    QATicketActivityId: number;
    QuestionId: number;
    IsComplete: boolean;
}

export class QualityGroupUsers {
     Username: string;
     QAProperty: string;
     Creation: Date;
}